import { debug } from 'debug';
export const logger = (subname) => {
    const log = debug(`tb`);
    if (subname) {
        return log.extend(subname);
    }
    return log;
};
export const setLogLevel = (val) => debug.enable(val);
//# sourceMappingURL=logger.js.map